import React from 'react';
import { siteContent } from '../data/mock';

export const Footer = () => {
  const { footer } = siteContent;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2C3E50]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="text-stone-300 text-sm">
            © {currentYear} {footer.copyright}
          </div>
          <div className="text-stone-400 text-sm">
            {footer.location}
          </div>
        </div>
      </div>
    </footer>
  );
};
